const baseURL = 'https://calender-and-event.onrender.com/api/'
// const baseURL = 'https://calendar-and-events-server.vercel.app/api/'
// const baseURL = 'https://calendar-and-events.herokuapp.com/api/';
// const baseURL = 'http://localhost:5001/api/';
export { baseURL }
